import React, { useContext, useEffect, useState } from "react";
import "./Withdrawal.css";
import Section_Header_Bar from "../../common_components/section_header_bar/Section_Header_Bar";
import { Form } from "react-bootstrap";
import Orange_White_Border_Btn from "../../common_components/common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import Inner_Footer_Text_Component from "../../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import Successfull_Modal from "../../common_components/common_modal/successfull_modal/Successfull_Modal";
import Success_Lottie from "../../animation/success_lottie/Success_Lottie";
import Verification_Steps_Modal from "../../common_components/common_modal/verification_steps_modal/Verification_Steps_Modal";
import Verify_Profile_Modal from "../../common_components/common_modal/verify_profile_modal/Verify_Profile_Modal";
import { useForm } from "react-hook-form";
import { Context } from "../../../utils/context";
import { postWithdrawalMoney } from "../../../utils/apis/withdrawal/withdrawal";
import Deposit_Lottie from "../../animation/deposit_lottie/Deposit_Lottie";
import { useNavigate } from "react-router-dom";
import { ApSetup } from "../../../utils/apis/master/Master";

const Withdrawal = () => {
  const navigate = useNavigate();
  const [verify, setVerify] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);

  const { userdata, getuserData } = useContext(Context);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (userdata?.accept_or_reject == 1) {
      setVerify(true);
    }
  }, [userdata]);

  const [appSetup, setAppSetup] = useState({});

  const getAppSetup = async () => {
    const res = await ApSetup();
    if (res?.success) {
      setAppSetup(res.data);
    }
  };

  useEffect(() => {
    getAppSetup();
  }, []);

  const onSubmit = async (data) => {
    const payload = {
      amount: data.amount,
    };

    try {
      const res = await postWithdrawalMoney(payload);
      if (res?.success) {
        setSuccessModal(true);
        getuserData(userdata?.id);
        setTimeout(() => {
          navigate("/transaction-history");
          setSuccessModal(false);
        }, 3000);
      } else {
        setError("amount", { message: res?.message || "Withdrawal failed" });
      }
    } catch (error) {
      console.error("API Error:", error);
      setError("amount", { message: "An error occurred. Please try again." });
    }
  };

  return (
    <section className="Withdrawal Deposit">
      <div className="header_div">
        <Section_Header_Bar />
      </div>

      <p className="section_title">Withdrawal</p>

      <div className="inner_section_box">
        <div className="inner_box">
          <div className="inner_container">
            {(verify === false || verify === 2) && (
              <div className="verification_div">
                <p className="warning_text">Verification Required</p>
                <p className="warning_text">
                  You need to verify your profile / Update Your Profile
                </p>

                <div className="verify_btn_div">
                  <Orange_White_Border_Btn
                    btn_name="Verify Profile"
                    onClick={() => setShowUploadModal(true)}
                  />
                </div>
              </div>
            )}

            {verify && (
              <>
                <p className="section_title">Withdrawal Amount</p>

                <Form onSubmit={handleSubmit(onSubmit)}>
                  <div className="outer_form_div">
                    <Form.Group className="custom_form_group">
                      <Form.Label className="black_input_label">
                        Withdrawal Amount
                      </Form.Label>
                      <Form.Control
                        className="blue_input"
                        type="number"
                        placeholder="Enter withdrawal amount"
                        {...register("amount", {
                          required: "Withdrawal amount is required", // Validation for required field
                          min: {
                            value: appSetup.min_withdrawl_amount,
                            message: `Minimum withdrawal amount is $${appSetup.min_withdrawl_amount}`, // Validation for minimum amount
                          },
                        })}
                      />
                    </Form.Group>
                    {errors.amount && (
                      <p className="text-danger mt-2">
                        {errors.amount.message}
                      </p>
                    )}
                  </div>

                  <div className="minimum_diposite_div">
                    <p className="text">
                      The minimum withdrawal amount is{" "}
                      {appSetup?.min_withdrawl_amount}$. A withdrawal fees of{" "}
                      {appSetup?.withdrawal_percent}% will be deducted.
                    </p>

                    <div className="orange_btn_div">
                      <Orange_White_Border_Btn
                        btn_name="Withdraw"
                        type="submit"
                        onClick={handleSubmit(onSubmit)}
                      />
                    </div>
                  </div>
                </Form>
              </>
            )}
          </div>
        </div>

        <div className="footer_text">
          <Inner_Footer_Text_Component />
        </div>
      </div>

      <Verification_Steps_Modal
        modal_title="Withdraw Successfully!"
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        lottie={<Success_Lottie />}
        setShowUploadModal={setShowUploadModal}
      />

      <Verify_Profile_Modal
        show={showUploadModal}
        onHide={() => {
          setShowUploadModal(false);
        }}
      />

      <Successfull_Modal
        message="WIthdraw Request Send Successfully!"
        show={successModal}
        onHide={() => {
          setSuccessModal(false);
        }}
        lottie={<Deposit_Lottie />}
      />
    </section>
  );
};

export default Withdrawal;
